import apiClient from '../lib/api/client';

/**
 * Tipos para Categories
 */
export interface Category {
  id: string | number;
  name?: string;
  code?: string;
  slug?: string;
  description?: string;
  min_age_months?: number;
  max_age_months?: number;
  parent_id?: string | number | null;
  created_at?: string;
  updated_at?: string;
}

export interface CategoriesResponse {
  items?: Category[];
  data?: Category[];
  categories?: Category[];
  // Fallback para diferentes estruturas de resposta da API
}

/**
 * Service para gerenciar requisições de Categories
 */
export const categoriesService = {
  /**
   * Busca todas as categorias
   */
  async getAll(): Promise<Category[]> {
    try {
      const response = await apiClient.get<CategoriesResponse | Category[]>('/categories');
      
      // Normaliza diferentes estruturas de resposta
      if (Array.isArray(response)) {
        return response;
      }
      
      if (response.items) {
        return response.items;
      }
      
      if (response.data) {
        return response.data;
      }
      
      if (response.categories) {
        return response.categories;
      }
      
      return [];
    } catch (error) {
      console.error('Erro ao buscar categorias:', error);
      throw error;
    }
  },

  /**
   * Busca uma categoria por ID
   */
  async getById(id: string | number): Promise<Category> {
    try {
      const response = await apiClient.get<Category>(`/categories/${id}`);
      return response;
    } catch (error) {
      console.error(`Erro ao buscar categoria ${id}:`, error);
      throw error;
    }
  },

  /**
   * Cria uma nova categoria
   */
  async create(data: Omit<Category, 'id' | 'created_at' | 'updated_at'>): Promise<Category> {
    try {
      const response = await apiClient.post<Category>('/categories', data);
      return response;
    } catch (error) {
      console.error('Erro ao criar categoria:', error);
      throw error;
    }
  },

  /**
   * Atualiza uma categoria existente
   */
  async update(id: string | number, data: Partial<Category>): Promise<Category> {
    try {
      const response = await apiClient.put<Category>(`/categories/${id}`, data);
      return response;
    } catch (error) {
      console.error(`Erro ao atualizar categoria ${id}:`, error);
      throw error;
    }
  },

  /**
   * Deleta uma categoria
   */
  async delete(id: string | number): Promise<void> {
    try {
      await apiClient.delete(`/categories/${id}`);
    } catch (error) {
      console.error(`Erro ao deletar categoria ${id}:`, error);
      throw error;
    }
  },
};

export default categoriesService;

